import { render } from "./MinimalLayout.vue?vue&type=template&id=64f15110"
import script from "./MinimalLayout.vue?vue&type=script&lang=js"
export * from "./MinimalLayout.vue?vue&type=script&lang=js"

import exportComponent from "/home/sentry/temp/sensoren/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__